export default function ComplianceDeadlinesSection() {
  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Key Compliance Deadlines
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay on track with critical SETA submission dates to ensure compliance and funding access
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="card p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-[#2D7F3E] text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">April 30</h3>
              <p className="text-[#2D7F3E] font-semibold">WSP & ATR Deadline</p>
            </div>
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-900">Workplace Skills Plan & Annual Training Report</h4>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                  <span>Submit annual training plan and skills gap analysis</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                  <span>Report on training completed and learner achievements</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-[#2D7F3E] mt-1 mr-2"></i>
                  <span>Submit supporting evidence for both submissions</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="card p-8">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-amber-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Ongoing</h3>
              <p className="text-amber-600 font-semibold">Discretionary Grants</p>
            </div>
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-900">Application Windows</h4>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-amber-600 mt-1 mr-2"></i>
                  <span>Multiple application periods</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-amber-600 mt-1 mr-2"></i>
                  <span>Sector-specific deadlines</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-amber-600 mt-1 mr-2"></i>
                  <span>Project-based submissions</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
          <div className="flex items-start">
            <i className="ri-error-warning-line text-red-500 text-2xl mr-4 mt-1"></i>
            <div>
              <h3 className="text-lg font-semibold text-red-800 mb-2">
                Warning: Late Submission Consequences
              </h3>
              <ul className="space-y-2 text-red-700">
                <li className="flex items-start">
                  <i className="ri-close-circle-line text-red-500 mr-2 mt-1"></i>
                  <span>Loss of mandatory grant funding for the year</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-close-circle-line text-red-500 mr-2 mt-1"></i>
                  <span>Ineligibility for discretionary grant applications</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-close-circle-line text-red-500 mr-2 mt-1"></i>
                  <span>Potential penalties and compliance issues</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-close-circle-line text-red-500 mr-2 mt-1"></i>
                  <span>Negative impact on B-BBEE scorecard</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}